import styled from 'styled-components';

export const RequiredLabel = (): JSX.Element => {
  return <Label>必須</Label>;
};

const Label = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ff6565;
  color: #fff;
  font-size: 0.625rem;
  padding: 0.0625rem 0.5rem;
  margin: 0;
  height: 0.8125rem;
  line-height: 1.7;
`;
